import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af53633e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "area-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "送信した資料を再利用して送信する", -1))
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" どの資料のメタデータを再利用するか選択してください。 ")
const _hoisted_6 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StopSend = _resolveComponent("StopSend")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_OuterSelect = _resolveComponent("OuterSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_StopSend)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Breadcrumb, {
        list: _ctx.list,
        pageNum: 1
      }, null, 8, ["list"])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_OuterSelect)
    ])
  ]))
}